<template>
  <div class="container-fluid container-top mt-5">
    <div class="row my-3">
      <div class="col-md-12">
        <div class="h2 text-head font-weight-bold">Upload Media</div>
      </div>
      <div class="col-md-12">
        <BackRoute />
      </div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Name</label>
      </div>
      <div class="col-md-5">
        <el-input type="text" class="w-100" v-model="uploadData.name" />
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Type</label>
      </div>
      <div class="col-md-5">
        <Dropdown
          :options="mediaTypes"
          style="width: 100%"
          v-model="uploadData.type"
        />
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Category</label>
      </div>
      <div class="col-md-5">
        <el-input type="text" class="w-100" v-model="uploadData.category" />
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Price</label>
      </div>
      <div class="col-md-5">
        <el-input type="text" class="w-100" v-model="uploadData.price" />
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Cover photo</label>
      </div>
      <div class="col-md-5">
        <button
          class="cover-picker"
          @click="() => (showImagePicker = !showImagePicker)"
        >
          {{
            cover && cover.name
              ? cover.name
              : uploadData.mediaFileImageUrl
              ? uploadData.mediaFileImageUrl
              : "Choose cover image"
          }}
        </button>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">File</label>
      </div>
      <div class="col-md-5">
        <input type="file" class="form-control" @change="fileUploaded" />
        <div class="s-13">Max. 28MB</div>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right">
        <label for="">Description</label>
      </div>
      <div class="col-md-5">
        <textarea
          class="w-100 form-control"
          rows="5"
          v-model="uploadData.description"
        ></textarea>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right"></div>
      <div class="col-md-5">
        <div class="row adjust-text d-flex justify-content-center">
          <div class="col-md-4 col d-flex align-items-center">
            <p class="mb-0">Is free</p>
            <Checkbox class="ml-2" v-model="uploadData.isFree" :binary="true" />
          </div>
          <div class="col-md-4 col d-flex align-items-center p-0">
            <p class="mb-0">Is Pushed</p>
            <Checkbox
              class="ml-2"
              v-model="uploadData.isPushed"
              :binary="true"
            />
          </div>
          <div class="col-md-4 col d-flex align-items-center p-md-0">
            <p class="mb-0">Is Public</p>
            <Checkbox class="ml-2" v-model="uploadData.public" :binary="true" />
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row my-3">
      <div class="col-md-4 text-md-right"></div>
      <div class="col-md-5 text-center">
        <el-button
          :color="primarycolor"
          round
          class="text-white border-0 mt-4 w-100 py-4"
          @click="uploadFile"
          :disabled="!file || !uploadData.type"
        >
          Upload
        </el-button>
      </div>
      <div class="col-md-3"></div>
    </div>

    <Dialog header="Uploading" v-model:visible="display" :modal="true">
      <ProgressBar
        :value="percentCompleted"
        style="max-width: 600px; width: 100%; min-width: 400px"
      />
    </Dialog>

    <Dialog
      header="Image Picker"
      v-model:visible="showImagePicker"
      :style="{ width: '70vw', maxWidth: '600px' }"
      :modal="true"
      position="top"
    >
      <ImagePicker @uploaded="imageSelected" />
    </Dialog>
  </div>
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import Checkbox from "primevue/checkbox";
import { ref, inject } from "vue";
import { useStore } from "vuex";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import membershipService from "../../../services/membership/membershipservice";
import axios from "@/gateway/backendapi";
import Dialog from "primevue/dialog";
import ProgressBar from "primevue/progressbar";
import ImagePicker from "../../../components/image-picker/ImagePicker";
import { ElNotification } from "element-plus";

const store = useStore();
const primarycolor = inject("primarycolor");
const display = ref(false);

const mediaTypes = ["Video", "Audio", "Ebook", "Picture"];
const uploadData = ref({});
const tenantId = ref(store.getters.currentUser.tenantId);

const cover = ref(null);
const file = ref(null);
const percentCompleted = ref(0);

const MAX_FILE_SIZE = 28 * 1024 * 1024; // 28MB

// Cover Upload
const coverUploaded = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  if (selectedFile.size > MAX_FILE_SIZE) {
    ElNotification({
      title: "Image Too Large",
      message: "The maximum cover size is 28MB. Please choose a smaller file.",
      type: "warning",
      duration: 4000,
    });
    e.target.value = "";
    cover.value = null;
    return;
  }

  cover.value = selectedFile;
  ElNotification({
    title: "Cover Selected",
    message: `${selectedFile.name} uploaded successfully.`,
    type: "success",
    duration: 3000,
  });
};

// File Upload
const fileUploaded = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  if (selectedFile.size > MAX_FILE_SIZE) {
    ElNotification({
      title: "File Too Large",
      message: "The maximum upload size is 28MB. Please choose a smaller file.",
      type: "warning",
      duration: 4000,
    });
    e.target.value = "";
    file.value = null;
    return;
  }

  file.value = selectedFile;
  ElNotification({
    title: "File Selected",
    message: `${selectedFile.name} uploaded successfully.`,
    type: "success",
    duration: 3000,
  });
};

// Upload File
const uploadFile = () => {
  const formData = new FormData();
  formData.append("mediaFileImage", cover.value ? cover.value : "");
  formData.append(
    "mediaFileImageUrl",
    uploadData.value.mediaFileImageUrl ? uploadData.value.mediaFileImageUrl : ""
  );
  formData.append("mediaFile", file.value ? file.value : "");
  formData.append("name", uploadData.value.name ? uploadData.value.name : "");
  formData.append(
    "mediaType",
    uploadData.value.type ? mediaTypes.indexOf(uploadData.value.type) : ""
  );
  formData.append(
    "description",
    uploadData.value.description ? uploadData.value.description : ""
  );
  formData.append(
    "category",
    uploadData.value.category ? uploadData.value.category : ""
  );
  formData.append(
    "price",
    uploadData.value.price ? uploadData.value.price : ""
  );
  formData.append("isFree", uploadData.value.isFree ? true : false);
  formData.append("public", uploadData.value.public ? true : false);
  formData.append("isPushed", uploadData.value.isPushed ? true : false);
  formData.append("tenantId", tenantId.value);

  display.value = true;

  axios
    .post("/api/Media/UploadMedia", formData, {
      onUploadProgress: function (progressEvent) {
        percentCompleted.value = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
      },
    })
    .then(() => {
      ElNotification({
        title: "Upload Success",
        message: "Your file was uploaded successfully.",
        type: "success",
        duration: 3000,
      });
      display.value = false;
    })
    .catch(() => {
      ElNotification({
        title: "Upload Failed",
        message: "The file upload failed, please try again.",
        type: "error",
        duration: 4000,
      });
      display.value = false;
    });
};

const getTenantId = () => {
  membershipService
    .getSignedInUser()
    .then((res) => {
      tenantId.value = res.tenantId;
    })
    .catch((err) => {
      console.log(err);
    });
};

if (!tenantId.value) {
  getTenantId();
}

const showImagePicker = ref(false);

const imageSelected = (e) => {
  if (e.isUrl) {
    uploadData.value.mediaFileImageUrl = e.data;
  } else {
    cover.value = e.data;
  }
  showImagePicker.value = false;
};
</script>

<style scoped>
button:disabled {
  opacity: 0.3;
}

.cover-picker {
  border: 1px solid #ced4da;
  width: 100%;
  padding: 0.3rem;
  text-align: left;
  background: transparent;
  overflow-x: hidden;
}

@media (max-width: 966px) {
  .adjust-text {
    font-size: 12px;
  }
}
</style>
